import { render, staticRenderFns } from "./VideoCallWithoutRecording.vue?vue&type=template&id=3912d2b5&scoped=true&"
import script from "./VideoCallWithoutRecording.vue?vue&type=script&lang=js&"
export * from "./VideoCallWithoutRecording.vue?vue&type=script&lang=js&"
import style0 from "./VideoCallWithoutRecording.vue?vue&type=style&index=0&id=3912d2b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3912d2b5",
  null
  
)

/* custom blocks */
import block0 from "./VideoCallWithoutRecording.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VideoCallWithoutRecording.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports